import { Flex, Input } from '@/components'
import { Button } from '@surein/ui'
import { SearchIcon } from 'lucide-react'
import styled from 'styled-components'
import { prop, ifProp } from 'styled-tools'

export const StyledInput = styled(Input)`
  width: 100%;
  padding-left: 40px;
`

export const StyledInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 400px;
  padding: 8px 0 0 8px;
`

export const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  left: 19px;
  color: ${(props) => props.theme.color.b50};
  width: 18px;
  height: 18px;
`

export const StyledDropdownContainer = styled.div`
  position: relative;
  background: white;
`

export const StyledDropDown = styled.div<{ isOpen: boolean; height?: string }>`
  position: absolute;
  top: 20;
  left: 0;
  height: ${ifProp('height', prop('height'), '360px')};
  z-index: 100;
  background-color: white;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.b30};
  opacity: ${ifProp('isOpen', 1, 0)};
  pointer-events: ${ifProp('isOpen', 'auto', 'none')};
  transition: opacity 0.3s;
`

export const StyledDropdownGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

export const StyledBottomRow = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 12px 16px;
  border-top: 1px solid ${(props) => props.theme.color.b30};

  button {
    width: 100%;
  }
`

export const StyledDropdownColumn = styled.div<{
  padding?: string
  borderRight?: boolean
  borderLeft?: boolean
  width?: string
  maxHeight?: string
}>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: ${ifProp('maxHeight', prop('maxHeight'), '238px')};
  overflow-y: auto;
  padding: ${ifProp('padding', prop('padding'), '0')};
  width: ${ifProp('width', prop('width'), 'auto')};
  border-left: ${(props) =>
    props.borderLeft ? `1px solid ${props.theme.color.b30}` : 'none'};
  border-right: ${(props) =>
    props.borderRight ? `1px solid ${props.theme.color.b30}` : 'none'};
`

export const StyledFiltersDisplay = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  max-width: 520px;
`

export const StyledRelativeContainer = styled(Flex)`
  position: relative;
  align-items: center;
  gap: 4px;
`

export const StyledXButton = styled(Button)`
  position: absolute;
  right: -16px;
  top: -14px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  color: ${(props) => props.theme.color.b50};
`
